<script>
import VDistributorEntityInfo from '@/components/v3/patterns/VDistributorEntityInfo/index';
import { mapActions, mapState } from 'vuex';
import EzButton from '@/components/ui/Button/EzButton';

/**
 *
 * @version 1.0.0
 * @since 2.4.0
 */
export default {
  components: {
    VDistributorEntityInfo,
    EzButton,
  },
  props: {
    distributor: {
      type: Object,
      required: true,
    },
    hasActions: {
      type: Boolean,
    },
  },
  data() {
    return {
      buttonType: 'primary',
    };
  },
  computed: {
    ...mapState('entities/users', [
      'contextId',
    ]),
    isAccepted() {
      return this.buttonType === 'green';
    },
  },
  methods: {
    accept() {
      this.buttonType = 'green';
      this.$emit('accepted');
    },
    downloadPdf() {
      this.$emit('download');
    },
    ...mapActions('entities/distributors', [
      'venueFetchSupplierSingle',
    ]),
  },
};
</script>
<template>
  <div class="footer">
    <div class="footer__container">
      <v-distributor-entity-info :distributor="distributor" />
      <div v-if="hasActions" class="footer__container--actions">
        <ez-button
          @click="downloadPdf"
          type="secondary">
          <font-awesome-icon icon="file-pdf"/>
          Download PDF
        </ez-button>
        <ez-button
          @click="accept"
          class="ml-12"
          :type="buttonType">
          <template v-if="isAccepted">
            <font-awesome-icon icon="check"/>
          </template>{{isAccepted ? 'Accepted' : 'I Accept'}}
        </ez-button>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
  .footer {
    background-color: #ffffff;
    border-top: 1px solid $color-gray-E9;
    width: 100%;
    height: auto;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;

    &__container {
      max-width: 792px;
      padding: 12px 24px;
      margin: 0 auto;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
  @media (max-width: 568px) {
    .footer {
      &__container {
        flex-direction: column;
        &--actions {
          margin-top: 8px;
          display: flex;
          width: 100%;
          button {
            flex: 1 1 50%;
          }
        }
      }
    }
  }
</style>
